import { useEffect, useState } from 'react';

export function usePainting(paintAt: (x: number, y: number) => void) {
  const [isPainting, setIsPainting] = useState(false);

  useEffect(() => {
    const stop = () => setIsPainting(false);
    window.addEventListener('pointerup', stop);
    window.addEventListener('pointercancel', stop);
    return () => {
      window.removeEventListener('pointerup', stop);
      window.removeEventListener('pointercancel', stop);
    };
  }, []);

  const onPointerDown = (e: React.PointerEvent) => {
    (e.target as HTMLElement).setPointerCapture?.(e.pointerId);
    setIsPainting(true);
    paintAt(e.clientX, e.clientY);
  };
  const onPointerMove = (e: React.PointerEvent) => {
    if (!isPainting) return;
    paintAt(e.clientX, e.clientY);
  };
  const onPointerUp = () => setIsPainting(false);

  return { onPointerDown, onPointerMove, onPointerUp };
}